import ClientFactory from '@/shared/factories/client'

const config = {
  baseURL: process.env.APIBaseURLAccess,
  headers: { 'Content-Type': 'application/json' }
}

const WebClient = ClientFactory.New(config)

WebClient.interceptors.request.use((request) => {
  return request
}, error => Promise.reject(error))

WebClient.interceptors.response.use(response => response, (error) => {
  return Promise.reject(error)
})

export default WebClient



// WEBPACK FOOTER //
// ./src/shared/http/clients/webclient.js